'use strict';
var parent = require('../../es/object/keys');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-auth-js/~/core-js/stable/object/keys.js
// module id = 495
// module chunks = 0